// extracted by mini-css-extract-plugin
export default {"container":"side_panel-module___container___cff87755"};